<template>
  <div
    
    class="block docx-file-block is-in-video-v2"
    :class="`item-${children.blockId}`"
  >
    <template v-if="showFileDIv">
    <div class="docx-block-zero-space">
      <span data-zero-space="true">&ZeroWidthSpace;</span>
    </div>
    <div contenteditable="false">
      <div class="docx-file-block-container docx-view-type-Preview" v-if="showFileMP4">
        <div class="preview-card-header">
          <div
            class="preview-card-header__mask preview-card-header__mask-video"
          ></div>
          <div class="preview-card-header__container">
            <svg width="18" height="18" viewBox="0 0 32 32">
              <defs>
                <path
                  d="M1.5 0h14.086a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V26.5a1.5 1.5 0 01-1.5 1.5h-19A1.5 1.5 0 010 26.5v-25A1.5 1.5 0 011.5 0z"
                  id="icon_file_video_nor_svg__a"
                ></path>
                <path
                  d="M16.293.293l5.414 5.414A1 1 0 0121.91 6H17.5A1.5 1.5 0 0116 4.5V.09a1 1 0 01.293.203z"
                  id="icon_file_video_nor_svg__b"
                ></path>
              </defs>
              <g fill="none" fill-rule="evenodd">
                <g transform="translate(5 2)">
                  <use
                    fill="#3370FF"
                    xlink:href="#icon_file_video_nor_svg__a"
                  ></use>
                  <use
                    fill="#245BDB"
                    xlink:href="#icon_file_video_nor_svg__b"
                  ></use>
                </g>
                <path d="M7 11h16.649v16.649H7z"></path>
                <path
                  d="M10.757 15h7.486c.383 0 .7.285.75.654l.007.103v7.486c0 .383-.285.7-.654.75l-.103.007h-7.486a.757.757 0 01-.75-.654L10 23.243v-7.486c0-.383.285-.7.654-.75l.103-.007h7.486zm11.819 1.792a.568.568 0 01.075.282v4.854a.568.568 0 01-.85.493l-1.799-1.028v-3.784l1.8-1.028a.568.568 0 01.774.211zM13.1 16.5h-1.2a.4.4 0 00-.4.4v1.2c0 .22.18.4.4.4h1.2a.4.4 0 00.4-.4v-1.2a.4.4 0 00-.4-.4z"
                  fill="#FFF"
                ></path>
              </g></svg
            ><span class="preview-card-header__container-title">{{
              children.blockAttr.file.name.slice(0, -4)
            }}</span>
          </div>
        </div>
        <div class="video-content">
         <div class="error-mask" v-if="errorText">{{errorText}}</div>
          <video
            controls
            playsinline="true"
            x5-playsinline="true"
            webkit-playsinline="true"
            mediatype="video"
            data-index="-1"
            @error="videoError"
            :id="`video-${children.blockId}`"
            :src="videoUrl"
          ></video>
        </div>
      </div>
      <div class="docx-file-block-container docx-view-type-Card" v-if="showFilePDF">
        <div class="file-block file-card">
          <div class="layout-column file-icon">
            <svg width="48" height="48" viewBox="0 0 32 32"><defs><path d="M1.5 0h14.086a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V26.5a1.5 1.5 0 01-1.5 1.5h-19A1.5 1.5 0 010 26.5v-25A1.5 1.5 0 011.5 0z" id="icon_file_pdf_nor_svg__a"></path><path d="M16.293.293l5.414 5.414A1 1 0 0121.91 6H17.5A1.5 1.5 0 0116 4.5V.09a1 1 0 01.293.203z" id="icon_file_pdf_nor_svg__b"></path></defs><g fill="none" fill-rule="evenodd"><g transform="translate(5 2)"><use fill="#F54A45" xlink:href="#icon_file_pdf_nor_svg__a"></use><use fill="#D83931" xlink:href="#icon_file_pdf_nor_svg__b"></use></g><path d="M7.649 10.703h16.648V27.35H7.65z"></path><path d="M23.674 21.179c-.344-.403-1.05-.6-2.158-.6-.645 0-1.532.017-2.424.15-2.436-1.757-3.007-3.643-3.007-3.643s.416-1.044.443-2.75c.017-1.078-.154-1.882-.59-2.228a1.224 1.224 0 00-.727-.27.971.971 0 00-.573.178c-1.266.914.117 5.22.154 5.336a38.289 38.289 0 01-2.126 4.336c-.251.438-.251.447-.42.646 0 0-2.217 1.1-3.256 2.318-.588.689-.607 1.162-.576 1.516.05.425.592.805 1.138.805.022 0 .045 0 .067-.002.555-.034 1.171-.186 1.857-.835.497-.47 1.056-1.746 1.774-2.995 2.06-.577 3.873-.989 5.392-1.224 1.114.592 2.772 1.261 3.9 1.261.38 0 .684-.076.906-.226.265-.18.378-.403.448-.817.07-.414-.027-.728-.222-.956zm-2.422.648c1.03 0 1.586.182 1.872.334.089.047.153.092.198.13-.08.062-.239.141-.526.141-.475 0-1.099-.201-1.86-.6.108-.003.214-.005.316-.005zm-5.91-9.077a.09.09 0 01.003-.004c.16.118.235.95.22 1.43-.02.647-.025.897-.106 1.294-.22-.828-.236-2.316-.116-2.72zm.052 6.05c.502.827 1.138 1.664 1.855 2.303-1.4.3-2.562.575-3.398.868a25.868 25.868 0 001.543-3.171zm-5.651 7.003c.127-.187.473-.55 1.35-1.252-.471 1.085-1 1.252-1.491 1.514.037-.086.083-.176.14-.262z" fill="#FFF"></path></g></svg>
          </div>
          <div class="layout-column layout-main-center flex-1">
            <div class="file-name">{{fileName}}</div>
            <div class="file-desc">
              <div></div>
            </div>
          </div>
          <div class="layout-row file-btn">
            <div class="btn-preview tooltip-host" @click="download">
              <span class="universe-icon media-preview-icon">
                <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-icon="DownloadOutlined"><path d="M20 18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v1h14v-1a1 1 0 0 1 1-1Zm-7-3.964 2.657-2.657a1 1 0 0 1 1.414 1.414c-1.414 1.415-2.828 2.83-4.244 4.244a1 1 0 0 1-1.412 0c-1.417-1.415-2.833-2.833-4.249-4.25a.993.993 0 0 1 .013-1.401.992.992 0 0 1 1.401-.013l2.42 2.42V3.5a1 1 0 1 1 2 0v10.536Z" fill="currentColor"></path></svg>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="docx-file-block-container " v-if="showFileZIP">
         <div class="file-block file-card">
          <div class="layout-column file-icon">
            <svg width="48" height="48" viewBox="0 0 32 32"><defs><path d="M1.5 0h14.086a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V26.5a1.5 1.5 0 01-1.5 1.5h-19A1.5 1.5 0 010 26.5v-25A1.5 1.5 0 011.5 0z" id="icon_file_zip_nor_svg__a"></path><path d="M16.293.293l5.414 5.414A1 1 0 0121.91 6H17.5A1.5 1.5 0 0116 4.5V.09a1 1 0 01.293.203z" id="icon_file_zip_nor_svg__b"></path></defs><g fill="none" fill-rule="evenodd"><g transform="translate(5 2)"><use fill="#3370FF" xlink:href="#icon_file_zip_nor_svg__a"></use><use fill="#245BDB" xlink:href="#icon_file_zip_nor_svg__b"></use></g><path d="M8 11h16.649v16.649H8z"></path><path d="M20 13a1 1 0 011 1v10a1 1 0 01-1 1h-8a1 1 0 01-1-1V14a1 1 0 011-1h8zm-2.7 5.5h-1.1a.2.2 0 00-.2.2v1.1c0 .11.09.2.2.2h1.1a.2.2 0 00.2-.2v-1.1a.2.2 0 00-.2-.2zM15.8 17h-1.1a.2.2 0 00-.193.147l-.007.053v1.1a.2.2 0 00.147.193l.053.007h1.1a.2.2 0 00.193-.147L16 18.3v-1.1a.2.2 0 00-.2-.2zm1.5-1.5h-1.1a.2.2 0 00-.193.147L16 15.7v1.1a.2.2 0 00.147.193L16.2 17h1.1a.2.2 0 00.193-.147l.007-.053v-1.1a.2.2 0 00-.2-.2zM15.8 14h-1.1a.2.2 0 00-.193.147l-.007.053v1.1a.2.2 0 00.147.193l.053.007h1.1a.2.2 0 00.193-.147L16 15.3v-1.1a.2.2 0 00-.2-.2zm-1.6 7h3.6c.11 0 .2.09.2.2v2.6a.2.2 0 01-.2.2h-3.6a.2.2 0 01-.2-.2v-2.6c0-.11.09-.2.2-.2zm.8 2h2v-1h-2v1z" fill="#FFF"></path></g></svg>
          </div>
          <div class="layout-column layout-main-center flex-1">
            <div class="file-name">{{fileName}}</div>
            <div class="file-desc">
              <div></div>
            </div>
          </div>
          <div class="layout-row file-btn">
            <div class="btn-preview tooltip-host" @click="download">
              <span class="universe-icon media-preview-icon">
                <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-icon="DownloadOutlined"><path d="M20 18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v1h14v-1a1 1 0 0 1 1-1Zm-7-3.964 2.657-2.657a1 1 0 0 1 1.414 1.414c-1.414 1.415-2.828 2.83-4.244 4.244a1 1 0 0 1-1.412 0c-1.417-1.415-2.833-2.833-4.249-4.25a.993.993 0 0 1 .013-1.401.992.992 0 0 1 1.401-.013l2.42 2.42V3.5a1 1 0 1 1 2 0v10.536Z" fill="currentColor"></path></svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="docx-block-zero-space">
      <span data-zero-space="true">&ZeroWidthSpace;</span>
    </div>
    </template>
    <div class="error-video-tip" v-else>
      <p>视频【{{ fileName }}】格式为【{{fileName.split('.')[1]}}】</p>
      <br />
      <p>请回到原飞书文档地址，下载视频文件，转码为【mp4】格式后重新上传视频  </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "file-block",
  props: {
    children: {
      type: Object,
      default: null,
    },
    tableId: {
      type: String,
      default: '',
    }
  },
  inject: ["isVirt"],
  computed: {
    fileName(){
      return this.children.blockAttr.file.name || ''
    },
    showFileDIv() {
      return this.showFileMP4 || this.showFilePDF || this.showFileZIP;
    },
    showFileMP4(){
      return this.fileName.toString().toLowerCase().indexOf(".mp4") > -1
    },
    showFilePDF(){
      return this.fileName.toString().toLowerCase().indexOf(".pdf") > -1
    },
    showFileZIP(){
      return this.fileName.toString().toLowerCase().indexOf(".zip") > -1
    },
    videoUrl() {
      return `/api/feishu/media/${this.children.blockAttr.file.token}`;
    },
  },
  data(){
    return {
      errorText: ''
    }
  },
  mounted(){
    if(this.tableId && !this.isVirt){
      this.$eventBus.$emit('changeTableWidth', this.tableId)
    }
  },
  methods:{
    download(){
      window.open(this.videoUrl, '_blank')
    },
    videoError(event){
      const error = event.target.error;
      switch(error.code) {
        case error.MEDIA_ERR_ABORTED:
          this.errorText = '视频获取过程被用户中止';
          break;
        case error.MEDIA_ERR_NETWORK:
          this.errorText = '下载时发生网络错误';
          break;
        case error.MEDIA_ERR_DECODE:
          this.errorText = '解码时发生错误';
          break;
        case error.MEDIA_ERR_SRC_NOT_SUPPORTED:
          this.errorText = '不支持视频源';
          break;
        default:
          this.errorText = '未知错误';
      }
    }
  }
};
</script>
<style>
.flex-1 {
    flex: 1;
}
.layout-main-center {
    justify-content: center;
}
.layout-column {
    display: flex;
    flex-direction: column;
}
.universe-icon {
    display: inline-block;
    font-style: normal;
    line-height: 0;
    text-align: center;
    text-transform: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.is-in-video-v2 .docx-view-type-Preview {
  width: 100%;
}
.docx-view-type-Card{
  position: relative;
    max-width: 400px;
}
.docx-file-block-container {
  border-radius: 8px;
  position: relative;
}
.docx-file-block-container .video-content{
  position: relative;
  display: flex;
}
.error-mask{
  position: absolute;
  inset: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  color:#FFFFFF;
  border-radius: 8px;
}
.docx-file-block .file-card {
    min-width: 200px;
    overflow: hidden;
}
.file-card {
    display: flex;
    width: 400px;
    max-width: 100%;
    font-size: 16px;
    position: relative;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #dee0e3;
    box-sizing: border-box;
    cursor: pointer;
    font-weight: 400;
    -webkit-user-select: none;
    user-select: none;
}
.file-card .file-icon {
    width: 48px;
    height: 48px;
    margin: 8px 12px 8px 8px;
}
.file-card .file-name {
    max-height: 44px;
    line-height: 22px;
    color: #1f2329;
    user-select: none;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.file-card .file-desc {
    height: 17px;
    white-space: nowrap;
    font-size: 12px;
    color: #646a73;
}
.file-card .file-desc, .file-card .file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
}
.file-card .file-btn {
    padding-right: 4px;
    margin-top: 8px;
    height: 48px;
    display: flex;
    align-items: center;
}
.file-card .btn-preview {
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #646a73;
    height: 34px;
    width: 34px;
    text-align: center;
    position: relative;
    overflow: unset;
    margin: 0 16px;
    cursor: pointer;
    padding: 4px;
    line-height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.file-card .btn-preview:hover {
    border-radius: 6px;
    background-color: rgba(31, 35, 41, 0.08);
}
.file-icon img{
  width: 48px;
  height: 48px;
}
.docx-file-block-container video {
  width: 100%;
  border-radius: 8px;
}
.preview-card-header {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: block;
  opacity: 0;
  transition: all 0.2s ease-out;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 60px;
  padding-left: 14px;
  padding-right: 14px;
  padding-top: 12px;
  z-index: 1;
}
.preview-card-header__mask.preview-card-header__mask-video {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  border-radius: 8px 8px 0 0;
}

.preview-card-header__container {
  display: flex;
  align-items: center;
}
.preview-card-header__container-title {
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  margin-left: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.docx-file-block-container:hover .preview-card-header {
  opacity: 1;
}
.error-video-tip{
  color: red;
  font-size: 14px;
  /* text-align: center; */
  border: 2px solid red;
  padding: 10px;
}
</style>